module.exports = __webpack_public_path__ + "static/朱辰昊-36氪36位36岁以下了不起的创业者-fb2291a1fb3a523ac42a0a8c51bf084e.jpg";